import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { http, inr, INSTAGRAM } from "../lib/api";
import { WA_NUMBER } from "../components/WhatsAppFab";
import { Eyebrow, MaskLine } from "../components/Reveal";

export default function OrderPage() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    http.get(`/orders/${id}`).then((r) => setO(r.data)).catch(() => setErr(true));
  }, [id]);

  if (err) return <div className="px-5 pt-40 text-center font-mono uppercase text-zinc-400">Order not found.</div>;
  if (!o) return <div className="min-h-screen px-5 pt-40 font-mono uppercase text-zinc-400">Loading…</div>;

  const paid = o.status === "paid";
  const waText = encodeURIComponent(
    `New T Brand order #${String(id).slice(-8).toUpperCase()}\n` +
      (o.items || []).map((it) => `• ${it.name} (Size ${it.size}) x${it.qty}`).join("\n") +
      `\nTotal: ₹${Number(o.total).toLocaleString("en-IN")}` +
      `\nPay: ${paid ? "Paid online" : o.status === "cod_pending" ? "Cash on delivery" : "To confirm"}` +
      `\nName: ${o.customer?.name || ""}\nPhone: ${o.customer?.phone || ""}\nAddress: ${o.customer?.address || ""}, ${o.customer?.city || ""}`
  );
  return (
    <section className="px-5 pb-24 pt-32 md:px-12" data-testid="order-success-screen">
      <div className="mx-auto max-w-4xl">
        <Eyebrow>Order #{String(id).slice(-8).toUpperCase()}</Eyebrow>
        <h1 className="mt-4 font-display text-6xl font-black uppercase leading-[0.85] md:text-8xl">
          <MaskLine>{paid ? "Locked in." : "Order"}</MaskLine>
          <MaskLine delay={0.12} className="text-[#00FF66]">{paid ? "It's yours." : o.status === "cod_pending" ? "COD placed." : "Reserved."}</MaskLine>
        </h1>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }} className="mt-6 max-w-xl text-zinc-300" data-testid="order-status-message">
          {paid
            ? `Payment received. Confirmation is on its way to ${o.customer?.email}. Ships in 3–5 days.`
            : o.status === "cod_pending"
              ? `Order placed. Keep ${inr(o.total)} ready in cash — pay when your order arrives.`
              : `Online payment is being switched on. Your pieces are held and we'll contact you at ${o.customer?.email} to complete payment.`}
        </motion.p>
        <div className="mt-10 divide-y divide-white/10 border-y border-white/10">
          {(o.items || []).map((it) => (
            <div key={`${it.slug}-${it.size}`} className="flex items-center gap-4 py-4">
              <img src={it.image} alt={it.name} className="h-20 w-16 object-cover" />
              <div className="flex-1">
                <p className="font-display text-2xl font-extrabold uppercase leading-none">{it.name}</p>
                <p className="font-mono text-xs uppercase text-zinc-400">Size {it.size} × {it.qty}</p>
              </div>
              <p className="font-mono">{inr(it.price * it.qty)}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 flex justify-between font-mono text-lg font-bold uppercase"><span>Total</span><span data-testid="order-total">{inr(o.total)}</span></div>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/" data-testid="continue-shopping-btn" className="bg-[#00FF66] px-6 py-4 font-display text-xl font-black uppercase text-black">Keep shopping</Link>
          <a href={`https://wa.me/${WA_NUMBER}?text=${waText}`} target="_blank" rel="noreferrer" data-testid="whatsapp-order-btn" className="bg-[#25D366] px-6 py-4 font-display text-xl font-black uppercase text-black">Send order on WhatsApp</a>
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="border border-white/20 px-6 py-4 font-display text-xl font-black uppercase hover:border-[#00FF66]">Follow @tbrand_111</a>
        </div>
      </div>
    </section>
  );
}
